export const REQUEST_ACCESS_EXPERIMENT_FLAG_V3 =
  'apollo.web.request-access-when-blocked-v3';

export enum AUTO_INVITE_MESSAGES {
  SUCCESS = 'You successfully added a member to the board',
  ERR0R = 'Error Occured',
}

// AUTO INVITE MEMBER SUCCESS FLOW

const SUCCESS_CONTENT_TITLE = 'Adding them now';
const SUCCESS__CONTENT_TEXT =
  "You'll soon be collaborating together on this board.";
const SUCCESS_BUTTON_TEXT = 'Go to board';
const DESCRIPTION = "We're adding:";

// WORKSPACE RESTRICTED CONTENT MODAL

const WORKSPACE_DIALOG_TITLE = 'Add to Workspace first';
const WORKSPACE_AVATAR_DESCRIPTION = (workspaceName: string): string =>
  `Add to ${workspaceName} Workspace`;
const WORKSPACE_DIALOG_DESCRIPTION =
  'Once added, they can join all visible boards and create new boards. You’ll be automatically billed for them too.';
const WORKSPACE_DIALOG_CANCEL_BUTTON = 'Cancel';
const WORKSPACE_DIALOG_ADD_BUTTON = 'Add to Workspace';

export const constants = {
  AUTO_INVITE_MESSAGES,
  REQUEST_ACCESS_EXPERIMENT_FLAG_V3,
  SUCCESS_CONTENT_TITLE,
  SUCCESS__CONTENT_TEXT,
  SUCCESS_BUTTON_TEXT,
  DESCRIPTION,
  WORKSPACE_DIALOG_TITLE,
  WORKSPACE_AVATAR_DESCRIPTION,
  WORKSPACE_DIALOG_DESCRIPTION,
  WORKSPACE_DIALOG_CANCEL_BUTTON,
  WORKSPACE_DIALOG_ADD_BUTTON,
};
